"use strict";import{defineElement as e}from"@spectrum-web-components/base/src/define-element.js";import{Tab as a}from"./src/Tab.js";e("sp-tab",a);
//# sourceMappingURL=sp-tab.js.map
